var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content partner_orders" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Обновить заявки",
                      loading: _vm.loading,
                      type: "button",
                      color: _vm.$constants.SUCCESS_COLOR,
                      onClick: () => _vm.getOrders(),
                      className: "btn btn-outline-success",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center mt-3",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records && _vm.records.length
            ? [
                _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-1" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (o, i) {
                        return _c(
                          "tr",
                          {
                            class: {
                              reserveComing: o.allowToShif,
                              collected: o.status === 2,
                            },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(o.id))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("p", [_vm._v(_vm._s(o.details.order.name))]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(o.details.order.mPhone)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.printDate(o.created_at))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.printStatus(o.status)),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm._l(o.details.drugs, function (d) {
                                  return _c("p", [
                                    _vm._v(_vm._s(d.title) + " x "),
                                    _c("strong", [_vm._v(_vm._s(d.qty))]),
                                    _vm._v(" x\n                "),
                                    _c("strong", [_vm._v(_vm._s(d.price))]),
                                  ])
                                }),
                                _vm._v(" "),
                                _c("hr", { staticClass: "mt-1 mb-1" }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: o.details.partner_comment,
                                        expression: "o.details.partner_comment",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Комментарий к заказу",
                                    },
                                    domProps: {
                                      value: o.details.partner_comment,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.updateOrder(
                                          o.id,
                                          "partner_comment"
                                        )
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          o.details,
                                          "partner_comment",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", [_c("strong", [_vm._v(_vm._s(o.price))])]),
                            _vm._v(" "),
                            _c("td", [
                              o.status === 2
                                ? _c("p", [
                                    _vm._v("Резерв до: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.printDate(o.details.reservedDate)
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  o.status === 2
                                    ? [
                                        _c(
                                          "v-popover",
                                          { attrs: { placement: "left" } },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn mb-2 btn-xs btn-outline-success",
                                                attrs: { type: "button" },
                                              },
                                              [_vm._v("Заказ выполнен")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "popover" },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    "Заказ выкуплен клиентом?"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("LoadingButton", {
                                                  attrs: {
                                                    title:
                                                      "Подтвердить выполнение заказа",
                                                    loading:
                                                      _vm.btnLoading[o.id],
                                                    type: "button",
                                                    color:
                                                      _vm.$constants
                                                        .PRIMARY_COLOR,
                                                    onClick: () =>
                                                      _vm.updateOrder(
                                                        o.id,
                                                        "close"
                                                      ),
                                                    className:
                                                      "mb-2 btn btn-xs btn-success",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    : [
                                        _c("LoadingButton", {
                                          attrs: {
                                            title: "Заказ собран",
                                            loading: _vm.btnLoading[o.id],
                                            type: "button",
                                            color: _vm.$constants.PRIMARY_COLOR,
                                            onClick: () =>
                                              _vm.updateOrder(o.id, "ready"),
                                            className:
                                              "mb-2 btn btn-xs btn-outline-info",
                                          },
                                        }),
                                      ],
                                  _vm._v(" "),
                                  o.allowToShif
                                    ? _c("LoadingButton", {
                                        attrs: {
                                          title: "Продлить бронь",
                                          loading: _vm.btnLoading[o.id],
                                          type: "button",
                                          color: _vm.$constants.PRIMARY_COLOR,
                                          onClick: () =>
                                            _vm.updateOrder(
                                              o.id,
                                              "reservedDate"
                                            ),
                                          className:
                                            "mb-2 btn btn-xs btn-outline-info",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-popover",
                                    { attrs: { placement: "left" } },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-xs btn-outline-warning",
                                          attrs: { type: "button" },
                                        },
                                        [_vm._v("Отменить заказ")]
                                      ),
                                      _vm._v(" "),
                                      _c("template", { slot: "popover" }, [
                                        _c(
                                          "form",
                                          {
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                                return _vm.updateOrder(
                                                  o.id,
                                                  "reject"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: o.reject_reason,
                                                  expression: "o.reject_reason",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                placeholder: "Причина отказа",
                                                rows: "2",
                                                required: "",
                                              },
                                              domProps: {
                                                value: o.reject_reason,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    o,
                                                    "reject_reason",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("LoadingButton", {
                                              attrs: {
                                                title: "подтвердить отмену",
                                                loading: _vm.btnLoading[o.id],
                                                type: "submit",
                                                color: "white",
                                                onClick: () => {},
                                                className:
                                                  "mt-2 btn btn-xs btn-warning",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            false
                              ? _c(
                                  "td",
                                  [
                                    _c(
                                      "v-dropdown",
                                      { attrs: { "show-arrow": false } },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "avatar",
                                            attrs: {
                                              slot: "activator",
                                              href: "#",
                                              "data-toggle": "dropdown",
                                              "aria-haspopup": "true",
                                              "aria-expanded": "false",
                                            },
                                            slot: "activator",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-default dropdown-toggle1",
                                                attrs: {
                                                  "data-toggle": "dropdown",
                                                  "aria-haspopup": "true",
                                                  "aria-expanded": "false",
                                                },
                                              },
                                              [
                                                _vm.btnLoading[o.id]
                                                  ? [
                                                      _c("clip-loader", {
                                                        attrs: {
                                                          loading: true,
                                                          color:
                                                            _vm.$constants
                                                              .LOADING_COLOR,
                                                          size: "20px",
                                                        },
                                                      }),
                                                    ]
                                                  : [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-fa icon-fa-ellipsis-v",
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-dropdown-item",
                                          [
                                            o.status === 0
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item pointer",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateOrder(
                                                            o.id,
                                                            "ready"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Заказ собран")]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            o.status === 2
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "dropdown-item pointer",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateOrder(
                                                            o.id,
                                                            "close"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Заказ закрыт")]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "dropdown-item pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateOrder(
                                                      o.id,
                                                      "reject"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Отменить заказ")]
                                            ),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : [
                !_vm.loading
                  ? [
                      _c("h5", { staticClass: "text-center" }, [
                        _vm._v("На данный момент активных заявок нет"),
                      ]),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID заказа")]),
        _vm._v(" "),
        _c("th", [_vm._v("Клиент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Статус")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Стоимость")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }